<template>
   <g>
      <path
         d="M4.0083 15.8559L12.0083 7.8559L20.0083 15.8559"
         stroke="currentColor"
         stroke-width="2"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-chevron-up',
         viewBox: '0 0 25 25',
         fill: 'none',
      };
   },
};
</script>
